import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { TRequestFilters } from './types'
import { getAlertasAbertosWithFilters } from './services'
import { TGetAlertasAbertos } from '../types'

const initialState = {
  status: "",
  data: []
}

export const actionGetAlertasByFilter = createAsyncThunk<Array<TGetAlertasAbertos>, TRequestFilters>(
  "ACTION_GET_ALERTAS_BY_FILTER",
  async (data) => {
    return getAlertasAbertosWithFilters(data)
  }
)

const sliceGetAlertasByFilter = createSlice({
  name: "GET_ALERTAS_BY_FILTER",
  initialState,
  reducers: {},
  extraReducers: {
    [`${actionGetAlertasByFilter.pending}`]: (state) => {
      state.status = "loading"
    },
    [`${actionGetAlertasByFilter.fulfilled}`]: (state, { payload }) => {
      state.status = "success"
      state.data = payload
    },
    [`${actionGetAlertasByFilter.rejected}`]: (state) => {
      state.status = "error"
    },
  }
})

export default sliceGetAlertasByFilter.reducer